export enum EvaluationResultEnum {
    POSITIVO = 'POSITIVO',
    NEGATIVO = 'NEGATIVO'
}

export enum TestReportResultEnum {
    CONFORME = 'CONFORME',
    NON_CONFORME = 'NON_CONFORME',
    CONFORME_CON_PA_MINORE_LMR_3 = 'CONFORME_CON_PA_MINORE_LMR_3'
}

export interface SampleCollectionCreationDTO {
    inspectionVisitId?: string
    samplingTime?: string
    samplingDate?: Date
    identifierCode?: string
    envelopeToLaboratory?: string
    envelopeToCustomer?: string
    firstEnvelopeToCodex?: string
    secondEnvelopeToCodex?: string
    materialSampled?: string
    lotNumber?: string
    collectionUnit?: string
    laboratoryId?: string
    note?: string
    plannedSampling?: boolean
    samplingCompleted?: boolean
    samplingResult?: EvaluationResultEnum
    principlesFound?: string
    multiresiduale?: boolean
    fosetylAl?: boolean
    glifosate?: boolean
    ogm?: boolean
    cloratiPerclorati?: boolean
    clormequatMepiquat?: boolean
    other?: boolean
    otherDetail?: string
    testReportNumber?: string
    testReportDate?: Date
    entryProtocolId?: string
    testReportResult?: TestReportResultEnum
    evaluationDate?: Date
    officerId?: string
}

export interface SampleCollectionUpdateDTO {
    samplingTime?: string
    samplingDate?: Date
    materialSampled?: string
    lotNumber?: string
    collectionUnit?: string
    laboratoryId?: string
    note?: string
    plannedSampling?: boolean
    samplingCompleted?: boolean
    samplingResult?: EvaluationResultEnum
    principlesFound?: string
    multiresiduale?: boolean
    fosetylAl?: boolean
    glifosate?: boolean
    ogm?: boolean
    cloratiPerclorati?: boolean
    clormequatMepiquat?: boolean
    other?: boolean
    otherDetail?: string
    testReportNumber?: string
    testReportDate?: Date
    entryProtocolId?: string
    testReportResult?: TestReportResultEnum
    evaluationDate?: Date
    officerId?: string
}

export interface SampleCollectionDTO {
    id: string
    inspectionVisitId: string
    samplingTime: string
    samplingDate: Date
    identifierCode: string
    envelopeToLaboratory: string
    envelopeToCustomer: string
    firstEnvelopeToCodex: string
    secondEnvelopeToCodex: string
    materialSampled: string
    lotNumber: string
    collectionUnit: string
    laboratoryId: string
    laboratoryInfo: string
    note: string
    plannedSampling: boolean
    samplingCompleted: boolean
    samplingResult: EvaluationResultEnum
    principlesFound: string
    multiresiduale: boolean
    fosetylAl: boolean
    glifosate: boolean
    ogm: boolean
    cloratiPerclorati: boolean
    clormequatMepiquat: boolean
    other: boolean
    otherDetail: string
    testReportNumber: string
    testReportDate: Date
    entryProtocolId: string
    entryProtocolInfo: string
    testReportResult: TestReportResultEnum
    evaluationDate: Date
    officerId: string
    officerInfo: string
}

export interface GetAllSampleCollectionDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: SampleCollectionDTO[]
}

export interface GetAllSampleCollectionFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    inspectionVisitId?: string
}

/* LABORATORY */

export interface LaboratoryDTO {
    id: string
    createdAt: Date | null
    updatedAt: Date | null
    deletedAt: Date | null
    name: string
    address: string
    contact: string
    email: string
    otherContact: string
    accreditationNumber: string
    convention: string
    note: string
    startingDate: Date
    endingDate: Date
}

export interface GetAllLaboratoryDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: LaboratoryDTO[]
}

export interface GetAllLaboratoryFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
}
